import { SovosButton, SovosDialog, SovosDialogActions, SovosDialogContent, SovosDialogTitle } from 'mosaic-react';

interface GenericDialogProps {
	open: boolean;
	title: string;
	message: string;
	confirmLabel: string;
	onConfirm: () => void;
	onCancel: () => void;
	isRedConfirmLabel?: boolean;
}

const GenericDialog = (props: GenericDialogProps) => {
	const { open, title, message, confirmLabel = 'CONFIRM', onConfirm, onCancel, isRedConfirmLabel = false } = props;

	return (
		<SovosDialog open={open} onClose={onCancel}>
			<SovosDialogTitle>{title}</SovosDialogTitle>
			<SovosDialogContent>
				<p>{message}</p>
			</SovosDialogContent>
			<SovosDialogActions>
				<SovosButton variant='text' onClick={onCancel}>
					CANCEL
				</SovosButton>
				<SovosButton variant='text' onClick={onConfirm} color={isRedConfirmLabel ? 'error' : 'primary'}>
					{confirmLabel}
				</SovosButton>
			</SovosDialogActions>
		</SovosDialog>
	);
};

export default GenericDialog;
